import { useSyncExternalStore } from 'react'

// Trạng thái THU GỌN sidebar — chia sẻ giữa Sidebar + Topbar (2 component tách
// nhau) qua store ngoài + useSyncExternalStore. Lưu localStorage để giữ nguyên
// sau reload. Mặc định = mở rộng (false). KHÔNG đụng logic nghiệp vụ.

const KEY = 'sidebar-collapsed'

function readInitial(): boolean {
  if (typeof localStorage === 'undefined') return false
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

let collapsed = readInitial()
const listeners = new Set<() => void>()

function emit(): void {
  for (const l of listeners) l()
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

function getSnapshot(): boolean {
  return collapsed
}

export function setSidebarCollapsed(next: boolean): void {
  if (collapsed === next) return
  collapsed = next
  try {
    localStorage.setItem(KEY, next ? '1' : '0')
  } catch {
    // localStorage có thể bị chặn (private mode) — bỏ qua, vẫn giữ state runtime.
  }
  emit()
}

export function toggleSidebarCollapsed(): void {
  setSidebarCollapsed(!collapsed)
}

// Đọc trạng thái + helper toggle. Mọi component gọi hook này cùng đọc 1 nguồn.
export function useSidebarCollapsed() {
  const value = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
  return { collapsed: value, toggle: toggleSidebarCollapsed, setCollapsed: setSidebarCollapsed }
}
